import { DEFAULT_LOSS_AND_DAMAGE_CLAIMS_TABLE_VIEW_COLUMNS } from '@/contants/ClaimsEnums';
import { generateUUIDv4 } from '@/utils/number';

import type { TableViewColumnsResponse } from './api';

export interface NormalizedTableViewColumn {
  columnName: string;
  columnValue: string;
  id: string;
}

export const normalizeTableViewColumns = (data: TableViewColumnsResponse): NormalizedTableViewColumn[] => {
  let columns = DEFAULT_LOSS_AND_DAMAGE_CLAIMS_TABLE_VIEW_COLUMNS;

  if (data?.length > 0) {
    columns = data.map(({ fieldReferenceName, fieldReferenceValue }) => ({
      columnName: fieldReferenceName,
      columnValue: fieldReferenceValue,
    }));
  }

  return columns.map((row) => ({ ...row, id: generateUUIDv4() }));
};
